'use client';
import React from 'react';
import { useTranslations } from 'next-intl';
import { Button } from '~/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import Link from 'next/link';

const LegalNotice = () => {
  const t = useTranslations('legal.legalNotice');
  const common = useTranslations('common');

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }}>
      <Button variant='ghost' style={{ marginBottom: '20px' }}>
        <Link href='/' className='flex items-center gap-2'>
          <ArrowLeft size={16} />
          {common('back')}
        </Link>
      </Button>
      
      <h1 style={{ fontSize: '2.5rem', marginBottom: '10px' }}>{t('title')}</h1>
      <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '40px' }}>
        {t('description')}
      </p>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '20px' }}>
          {t('sections.legalBase.title')}
        </h2>
        <p style={{ lineHeight: '1.6', fontSize: '1rem', marginBottom: '20px' }}>
          {t('sections.legalBase.content')}
        </p>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '20px' }}>
          {t('sections.publisher.title')}
        </h2>
        <div style={{ lineHeight: '1.6', fontSize: '1rem', whiteSpace: 'pre-line' }}>
          {t('sections.publisher.content')}
        </div>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '20px' }}>
          {t('sections.hosting.title')}
        </h2>
        <div style={{ lineHeight: '1.6', fontSize: '1rem', whiteSpace: 'pre-line' }}>
          {t('sections.hosting.content')}
        </div>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '20px' }}>
          {t('sections.contact.title')}
        </h2>
        <p style={{ lineHeight: '1.6', fontSize: '1rem' }}>
          {t('sections.contact.content')}
        </p>
      </div>

      <div style={{ marginTop: '60px', textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
        <p>{t('copyright', { year: new Date().getFullYear() })}</p>
      </div>
    </div>
  );
};

export default LegalNotice;
